var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Component from '@arco-design/web-react/es/AutoComplete';
import Input from '@arco-design/web-react/es/Input';
import Select from '../select';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
function TriggerElement(props, ref) {
    var _a = props.height, height = _a === void 0 ? 36 : _a, _b = props.allowClear, allowClear = _b === void 0 ? true : _b, onSearch = props.onSearch;
    return (React.createElement(Input.Search, __assign({}, props, { ref: ref, height: height, onSelect: undefined, allowClear: allowClear, onSearch: function (value) {
            setPopueElementDisplay('none');
            onSearch && onSearch(value);
        } })));
}
var ForwardRefTriggerElement = React.forwardRef(TriggerElement);
var AutoComplete = function (props, ref) {
    var className = props.className, onSelect = props.onSelect, onChange = props.onChange;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-search";
    return React.createElement(Component, __assign({}, props, { onSearch: onChange, triggerElement: React.createElement(ForwardRefTriggerElement, __assign({}, props, { ref: ref })), onSelect: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setPopueElementDisplay('none');
            var event = window.event;
            if (event && event.keyCode === 13) {
                return;
            }
            onSelect && onSelect.apply(void 0, args);
        }, onChange: function (value) {
            var display = !value ? 'none' : 'block';
            setPopueElementDisplay(display);
        }, className: cx(className, prefixCls) }));
};
var ForwardRefAutoComplete = React.forwardRef(AutoComplete);
function setPopueElementDisplay(status) {
    var popupElement = document.getElementsByClassName('arco-autocomplete-popup')[0];
    popupElement && (popupElement.style.display = status);
}
var Search = ForwardRefAutoComplete;
Search.Option = Select.Option;
Search.OptGroup = Select.OptGroup;
Search.displayName = 'Search';
export default Search;
//# sourceMappingURL=index.js.map